export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14818.c0740d5d.jpg";